import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { PrivacyModel } from "common/models/page-models/privacy/privacy-data-model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { FormDataService } from "../Intership-List/intership-filter-form-data.service";
import { Injectable } from "@angular/core";
import { editInfo } from "common/models/utility-models/utility-interface";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class PrivacyDataService extends FormDataService<PrivacyModel> {

    constructor(apiService: SmApiService, protected override ss: SystemService) {
        super(API_URL.privacyTerms, apiService, ss);
    }

    createInstance(): PrivacyModel {
        return new PrivacyModel();
    }

    override getUpdatePayload(data: any) {
        return {};
    }

    getEditUrlAndMethod() {
        const edit = {
          url: environment.apiUrl + API_URL.privacyTerms,
          method: API_METHODS.post,
        };
        return edit;
      }

 
 
}